import { createSlice } from '@reduxjs/toolkit';

import { handleGetProgramCodes } from './actions';
import { IProgramCodesState } from './slice.interface';

const initialState: IProgramCodesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const programCodesSlice = createSlice({
  name: 'program-codes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetProgramCodes.pending, (state: IProgramCodesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetProgramCodes.rejected, (state: IProgramCodesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetProgramCodes.fulfilled, (state: IProgramCodesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export default programCodesSlice.reducer;
